import { render, staticRenderFns } from "./BuildingLookup.vue?vue&type=template&id=47faa28e&scoped=true&"
import script from "./BuildingLookup.vue?vue&type=script&lang=js&"
export * from "./BuildingLookup.vue?vue&type=script&lang=js&"
import style0 from "./BuildingLookup.vue?vue&type=style&index=0&id=47faa28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47faa28e",
  null
  
)

export default component.exports